import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SERVICE_DATA, SERVICE_THEMES } from '../../../data/serviceData';

/**
 * RelatedServices — horizontal cards linking to other services.
 * Props:
 *   relatedSlugs – array of slug strings
 */
export default function RelatedServices({ relatedSlugs }) {
  const navigate = useNavigate();

  if (!relatedSlugs?.length) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {relatedSlugs.map((slug) => {
        const svc = SERVICE_DATA[slug];
        const svcTheme = SERVICE_THEMES[slug];
        if (!svc) return null;
        const Icon = svc.icon;

        return (
          <button
            key={slug}
            onClick={() => navigate(`/dashboard/services/${slug}`)}
            className="flex items-center gap-3 p-4 rounded-xl text-left transition-all duration-200 hover:scale-[1.01] hover:shadow-sm group"
            style={{ backgroundColor: svcTheme.lightBg }}
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
              style={{ backgroundColor: `${svcTheme.accent}20` }}
            >
              <Icon className="w-5 h-5" style={{ color: svcTheme.accent }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-gray-800 truncate">{svc.name}</p>
              <p className="text-xs text-gray-500 mt-0.5">From {svc.price}</p>
            </div>
            <ArrowRight className="w-4 h-4 text-gray-300 group-hover:text-gray-500 transition-colors shrink-0" />
          </button>
        );
      })}
    </div>
  );
}
